import Upload2LineIcon from "remixicon-react/Upload2LineIcon";
import { Button as UIButton } from "@mui/material";
import { Text as InternalText } from "$components";
import useEDB from "$hooks/useEDB";
import useParcel from "$hooks/useParcel";

function PDFDownloader({ opData, disabled = false }: any) {
  const { generatePDF } = useEDB();
  const { parcel } = useParcel(opData?._id);

  return (
    <UIButton
      disabled={disabled}
      onClick={() => {
        generatePDF(opData?._id, {
          ...opData,
          parcel: parcel && Object.keys(parcel).length ? parcel : null,
        });
      }}
    >
      <Upload2LineIcon
        style={{
          marginRight: "10px",
          fill: disabled ? "#999 !important" : "#2D2D2D !important",
        }}
      />
      <InternalText
        style={{
          textDecoration: "none",
          display: "flex",
          alignItems: "center",
          color: disabled ? "#999" : "#2D2D2D",
          textTransform: "none",
        }}
      >
        Exporter en PDF
      </InternalText>
    </UIButton>
  );
}

export default PDFDownloader;
